import { observable, action, computed, runInAction, decorate } from 'mobx';
import agent from '../api/agent';
import { IRequest, RequestFormValues } from '../models/Request';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';

// const LIMIT = 10;

export default class RequestStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        // reaction(
        //     () => this.predicate.keys(),
        //     () => {
        //         this.page = 0;
        //         this.RequestRegistry.clear();
        //         this.loadRequests();
        //     }
        // )
    }

    RequestRegistry = new Map();
    Request: IRequest | null = null;
    loadingInitial = false;
    submitting = false;
    target = "";
    limit = 10;
    requestCount = 0;
    totalPages = 0;
    page = 0;
    predicate = new Map();
    sortBy = 'requestDate';
    sortOrder = 'ascending' as 'ascending'|'descending'| undefined;
    quickFilters = ["OpenRequests", "all", "IsSpanish", "ReviewerById"]
    setPredicate = async (predicate: string, value: string | Date) => {
        // if(this.quickFilters.includes(predicate)){
        //     this.predicate.clear();
        //     if (predicate !== 'all') {
        //         this.predicate.set(predicate, value);
        //     }
        //     this.RequestRegistry.clear();
        // }
        // else{
        //     this.predicate.set(predicate, value);
        //     this.RequestRegistry.clear();
        // }

        this.predicate.set(predicate, value);
        this.page = 0;
        this.RequestRegistry.clear();
        await this.loadTableRequests();


    }
    clearPredicates = () =>{
        this.predicate.clear();
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(this.limit));
        params.append('offset', `${this.page ? this.page * this.limit : 0}`);
        params.append('sortBy', `${this.sortBy}`);
        params.append('sortOrder', `${this.sortOrder==='ascending'?'asc':'desc'}`);
        this.predicate.forEach((value, key) => {
            if (key === 'startDate') {
                params.append(key, value.toISOString);
            } else {
                params.append(key, value);
            }
        })
        return params;
    }


    // get totalPages() {
    //     return Math.ceil(this.requestCount / this.limit);
    // }

    setSort = (sortOrder: 'ascending'| 'descending'|undefined, sortBy:string) => {
        this.sortOrder = sortOrder;
        this.sortBy = sortBy;
        // await this.loadTableRequests();
    }
    setLimit = (limit: number) => {
        this.limit = limit;
        this.setPage(0)
    }
    setPage = (page: number) => {
        this.page = page;
    }

    get requestsById() {
        return this.groupRequestsById(Array.from(this.RequestRegistry.values()));
    };

    groupRequestsById(requests: IRequest[]) {
        const sortedRequests = requests.sort(
            (a, b) => parseInt(b.requestCaseID) - parseInt(a.requestCaseID)
        )

        return Object.entries(sortedRequests.reduce((requests, request) => {
            const id = request.requestCaseID;
            requests[id] = requests[id] ? [...requests[id], request] : [request];
            return requests;
        }, {} as { [key: string]: IRequest[] }));
    }




    get requestsByDate() {
        return Array.from(this.RequestRegistry.values()).sort(
            (b: IRequest, a: IRequest) => (a.age) - (b.age)
        );
    };

    get requests() {
        return Array.from(this.RequestRegistry.values());
    };

    incrementRequestNote = (id: string) => {
        let request = this.RequestRegistry.get(id)
        request.noteCount += 1;
        this.RequestRegistry.set(id, request)
    }

    loadTableRequests = async () => {
        runInAction( () => {
            this.loadingInitial = true;
        });

        try {
            const requestsEnvelope = await agent.Requests.list(this.axiosParams);
            const { requestsDto, requestCount } = requestsEnvelope;

            runInAction( () => {
                this.RequestRegistry.clear();
                requestsDto.forEach((request) => {
                    // appeal.submittedOn=new Date(appeal.submittedOn);
                    this.RequestRegistry.set(request.id, request);
                });
                this.requestCount = requestCount;
                this.totalPages = Math.ceil(requestCount / this.limit)
                this.loadingInitial = false;
            });


        } catch (error) {
            runInAction( () => {
                this.loadingInitial = false;
            });

            throw error;
        }
    };
    loadRequests = async () => {
        this.loadingInitial = true;
        try {
            const requestsEnvelope = await agent.Requests.list(this.axiosParams);
            const { requestsDto, requestCount } = requestsEnvelope;

            runInAction('loadRequests', () => {
                requestsDto.forEach((request) => {
                    // appeal.submittedOn=new Date(appeal.submittedOn);
                    this.RequestRegistry.set(request.id, request);
                });
                this.requestCount = requestCount;
                this.totalPages = Math.ceil(this.requestCount / this.limit)
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadRequests', () => {
            this.loadingInitial = false;
        });
    };

    clearRequests = () => {
        this.RequestRegistry.clear();
    }

    initLoadTableRequests = async() =>{
        this.clearRequests();
        this.predicate.set('OpenRequests', 'true');
        await this.loadTableRequests();
    }
    updateRequestToSpanish = async (id: string, isSpanish: boolean) => {
        this.rootStore.requestReviewStore.loadingInitial = true;
        try {

            const requestForm = new RequestFormValues(id, isSpanish);
            await agent.Requests.update(id, requestForm);

            runInAction('updateRequestToSpanish', () => {
                this.rootStore.requestReviewStore.RequestReview!.spanishRequest = isSpanish;
            });

        } catch (error) {
            throw error;
        }
        runInAction('updateRequestToSpanish', () => {
            this.rootStore.requestReviewStore.loadingInitial = false;
        });
    };

    loadRequest = async (id: string) => {
        let Request = this.getRequest(id);
        this.loadingInitial = true;
        try {
            Request = await agent.Requests.details(id);
            runInAction('getting activity', () => {
                this.Request = Request;
                this.RequestRegistry.set(Request.id, Request);
                this.loadingInitial = false;
            })
            //return Request;
        } catch (error) {
            toast.error('problem submitting data');
        }
        runInAction('loadActivities', () => {
            this.loadingInitial = false;
        });
    };
    resendToTRD = async (id: string) => {
        // let Request = this.getRequest(id);
        this.loadingInitial = true;
        try {
            await agent.Requests.resend(id);

            toast.success('Request resent to TRD');
            runInAction('resendToTRD', () => {
                this.rootStore.modalStore.closeModal();
                this.loadingInitial = false;
            });
            //return Request;
        } catch (error) {
            console.log(error)
            this.rootStore.modalStore.closeModal();
            this.loadingInitial = false;
            toast.error('problem resending request');
            throw error;
        }
        runInAction('resendToTRD', () => {
            this.rootStore.modalStore.closeModal();
            this.loadingInitial = false;
        });
    };

    getRequest = (id: string) => {
        return this.RequestRegistry.get(id);
    }

    ClearRequest = () => {
        this.Request = null;
    }

}
decorate(RequestStore, {
    RequestRegistry: observable,
    Request: observable,
    loadingInitial: observable,
    submitting: observable,
    target: observable,
    requestCount: observable,
    limit: observable,
    page: observable,
    predicate: observable,
    totalPages: observable,
    sortOrder: observable,
    sortBy: observable,

    loadRequest: action,
    loadRequests: action,
    loadTableRequests: action,
    clearRequests: action,
    ClearRequest: action,
    setPredicate: action,
    clearPredicates: action,
    setPage: action,
    setLimit: action,
    incrementRequestNote: action,
    updateRequestToSpanish: action,
    resendToTRD: action,
    setSort: action,
    initLoadTableRequests: action,

    requestsById: computed,
    requestsByDate: computed,
    requests: computed,
    axiosParams: computed,
    // totalPages: computed
});